// extracted by mini-css-extract-plugin
export default {"bar":"StatsBar_bar__kkXMm","stat":"StatsBar_stat__UGZug","num":"StatsBar_num__opV3J","label":"StatsBar_label__gi0PQ"};